import React, { useRef, useEffect } from "react";
import styled, { css } from "styled-components/macro";
import { BsFillXOctagonFill } from "react-icons/bs";
import { Label } from "reactstrap";

const FormComponents = (props) => {
  const {
    id = "",
    compType = "",
    type = "",
    disabled = false,
    value = "",
    options = [],
    onChange = () => null,
    allowMultipleFile = false,
    accept = "",
    min,
    error = "",
    affixLabel = "",
    onKeyDown,
    radiolabel = [],
    checked = "",
  } = props;

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (type === "file") {
      if (fileInputRef && fileInputRef.current && !value) {
        fileInputRef.current.value = "";
      }
    }
  }, [value]);

  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();

  if (typeof compType === "function") {
    return compType(props);
  } else if (compType === "input" && type !== "checkbox") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <StyledInput
            id={`input_${id}`}
            type={type ? type : "text"}
            value={value}
            min={min}
            onChange={(event) => onChange(id, event.target.value, event)}
            disabled={disabled}
            onKeyDown={onKeyDown ? (event) => onKeyDown(id, event.code, event) : type === "number" ? blockInvalidChar : undefined}
            error={error}
            autoComplete="off"
          />
          {error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p>{error}</p></ FormErrorSectionDiv> : null}
        </MultiTagWrapper>
        {/* <FormErrorSectionDiv>
              {error ? <BsFillXOctagonFill /> : null }
            </FormErrorSectionDiv> */}
        {affixLabel ? <label id="affixLabel">{affixLabel}</label> : null}
      </StyledWrapper>
    );
  } else if (compType === "input" && type === "checkbox") {
    return (
      <StyledWrapper>
        <StyledInput
          id={`input_${id}`}
          type="checkbox"
          checked={value}
          onChange={(event) => onChange(id, event.target.checked, event)}
          disabled={disabled}
        />
        {error ? (
          <FormErrorSectionDiv>
            <BsFillXOctagonFill />
          </FormErrorSectionDiv>
        ) : null}
      </StyledWrapper>
    );
  } else if (compType === "integerDropdown") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <StyledSelect
            id={id}
            name={id}
            value={value}
            onChange={(event) => onChange(id, parseInt(event.target.value), event)}
            error={error}
            disabled={disabled}
          >
            {options.length
              ? options.map((item) => (
                <option key={`${id}_${item.value}`} value={item.value}>
                  {item.label}
                </option>
              ))
              : null}
          </StyledSelect>
          {error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p>{error}</p></FormErrorSectionDiv> : null}
        </MultiTagWrapper>
        {/* {error ? (
            <FormErrorSectionDiv>
              <BsFillXOctagonFill />
            </FormErrorSectionDiv>
          ) : null} */}
      </StyledWrapper>
    );
  }else if (compType === "dropdown") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <StyledSelect
            id={id}
            name={id}
            value={value}
            onChange={(event) => onChange(id, event.target.value, event)}
            error={error}
            disabled={disabled}
          >
            {options.length
              ? options.map((item) => (
                <option key={`${id}_${item.value}`} value={item.value}>
                  {item.label}
                </option>
              ))
              : null}
          </StyledSelect>
          {error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p>{error}</p></FormErrorSectionDiv> : null}
        </MultiTagWrapper>
        {/* {error ? (
            <FormErrorSectionDiv>
              <BsFillXOctagonFill />
            </FormErrorSectionDiv>
          ) : null} */}
      </StyledWrapper>
    );
  } else if (compType === "file") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <StyledInput type="text" value={value} error={error} disabled={disabled} />
          {error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p style={{ "padding-left": "7px", "margin-top": "2px" }}>{error}</p></FormErrorSectionDiv> : null}
        </MultiTagWrapper>
        <StyledInput
          id={`input_${id}`}
          name={`input_${id}`}
          type="file"
          ref={fileInputRef}
          accept={accept}
          onChange={(event) =>{
            onChange(id, Array.from(event.target.files), event)
            event.target.value = null
            }
          }
          disabled={disabled}
          multiple={allowMultipleFile}
        />
        {/* <FormErrorSectionDiv>
              {
                error ? <BsFillXOctagonFill /> : null
              }
            </FormErrorSectionDiv> */}

        <Button
          for={`input_${id}`}
          error={error}
          disabled={disabled}>
          Browse...
        </Button>

      </StyledWrapper>
    );
  } else if (compType === "doubleDropdown") {
    const handleMinChange = (event) => {
      const minValue = event.target.value;
      onChange(id, { ...value, min: minValue }, event);
    };

    const handleMaxChange = (event) => {
      const maxValue = event.target.value;
      onChange(id, { ...value, max: maxValue }, event);
    };

    return (
      <StyledWrapper>
            <MultiTagWrapper style={{ margin: "3px 0 5px 0"}}>
              <span>
              <span id="label" style={{ margin: "9px 5px 0 0", fontWeight: "600" }}>Min:</span>
              <StyledDropdown
                id={`${id}_min`}
                name={`${id}_min`}
                value={value.min}
                onChange={handleMinChange}
                error={error}
                disabled={disabled}
              >
                {options.length
                  ? options.map((item, index) => (
                    <option
                      key={`${id}_min_${item.value}`}
                      value={item.value}
                    >
                      {item.label}
                    </option>
                  ))
                  : null}
              </StyledDropdown>
              <span style={{ margin: "9px 5px 0 15px", fontWeight: "600" }}>Max:</span>
              <StyledDropdown
                id={`${id}_max`}
                name={`${id}_max`}
                value={value.max}
                onChange={handleMaxChange}
                error={error}
                disabled={disabled}
              >
                {options.length
                  ? options.map((item, index) => (
                    <option
                      key={`${id}_max_${item.value}`}
                      value={item.value}
                    >
                      {item.label}
                    </option>
                  ))
                  : null}
              </StyledDropdown>
              </span>
              {error ? (
                <FormErrorSectionDiv>
                  <p>{error}</p>
                </FormErrorSectionDiv>
              ) : null}
            </MultiTagWrapper>
            {affixLabel ? <label id="affixLabel">{affixLabel}</label> : null}
      </StyledWrapper>
    );
  } else if (compType === "numInput") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <NumStyledInput
            id={`input_${id}`}
            type={type ? type : "text"}
            value={value}
            onInput={(e) => e.target.value = e.target.value.slice(0, 5)}
            onChange={(event) => onChange(id, event.target.value, event)}
            disabled={disabled}
            onKeyDown={onKeyDown ? (event) => onKeyDown(id, event.code, event) : type === "number" ? blockInvalidChar : undefined}
            error={error}
            autoComplete="off"
          />
          {error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p>{error}</p></ FormErrorSectionDiv> : null}
        </MultiTagWrapper>
        {affixLabel ? <label id="affixLabel">{affixLabel}</label> : null}
      </StyledWrapper>
    );
  } else if (compType === "numType") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <NumStyledInput
            id={`input_${id}`}
            type={type ? type : "text"}
            value={value}
            onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
            onChange={(event) => onChange(id, event.target.value, event)}
            disabled={disabled}
            onKeyDown={onKeyDown ? (event) => onKeyDown(id, event.code, event) : type === "number" ? blockInvalidChar : undefined}
            error={error}
            autoComplete="off"
          />
          {error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p>{error}</p></ FormErrorSectionDiv> : null}
        </MultiTagWrapper>
        {affixLabel ? <label id="affixLabel">{affixLabel}</label> : null}
      </StyledWrapper>
    );
  } else if (compType === "btn") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <UploadCertiButton onClick={(event) => onChange(event)} />
        </MultiTagWrapper>
      </StyledWrapper>
    );
  } else if(compType === "doubleRadio"){
    return (
      <div style={{display: 'flex'}}>
        <StyledWrapper>
          <MultiTagWrapper>
            <RadioButton
              id={`input_${id}`}
              type={type ? type : "radio"}
              name="Hub"
              value={radiolabel[0]}
              onChange={(event) => onChange(id,event.target.value,event)}
              checked={checked === "Primary Hub"}
            />
            <Label id="radio_option1" style={{ fontFamily: "Verdana"}}>
              {radiolabel && radiolabel[0] ? radiolabel[0] : "Label 1"}
            </Label>
          </MultiTagWrapper>
        </StyledWrapper>
        <span style={{marginLeft: "15px"}}></span>
        <StyledWrapper>
          <MultiTagWrapper>  
            <RadioButton
              id={`input_${id}`}
              type={type ? type : "radio"}
              name="Hub"
              value={radiolabel[1]}
              onChange={(event) => onChange(id,event.target.value,event)}
              checked={checked === "Failover Hub"}
            />
            <Label id="radio_option2" style={{ fontFamily: "Verdana"}}>
              {radiolabel && radiolabel[1] ? radiolabel[1] : "Label 2"}
            </Label>
          </MultiTagWrapper>
        </StyledWrapper>
    </div>
    )

  } else {
    return null;
  }
};

export default FormComponents;


export const StyledSelect = styled.select`
  width: 260px;
  height: 28px;
  border: 1px solid #a9a9a9;
  cursor: pointer;
  color: #333;
  padding-left: 2px;
  font-size: 1rem;
  font-family: Verdana;
  border-radius: 4px;
  option {
    height: 25px;
  }
  &:focus,
  :focus-visible {
    outline: none;
  }
  ${(props) =>
    props.error
      ? css`
          border-color: #C31200; background-color: #fbf4f4;
        `
      : ""}
`;

export const StyledDropdown = styled.select`
  width: 100px;
  height: 28px;
  border: 1px solid #a9a9a9;
  cursor: pointer;
  color: #333;
  padding-left: 2px;
  font-size: 1rem;
  font-family: Verdana;
  border-radius: 4px;
  option {
    height: 25px;
  }
  &:focus,
  :focus-visible {
    outline: none;
  }
  ${(props) =>
    props.error
      ? css`
          border-color: #C31200; 
        `
      : css`
          border-color: black`}
`;

export const StyledInput = styled.input`
  width: 330px;
  height: 28px !important;
  border: 1px solid #a9a9a9 !important;
  color: #333;
  padding-left: 5px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  font-size: 1rem !important;
  font-family: Verdana;
  border-radius: 4px;
  &:disabled {
    border-color: #babfc7 !important;
    color: #898989;
    background-color: #fff;
  }
  &:focus,
  :focus-visible {
    outline: none;
  }
  ${(props) =>
    props.error
      ? css`
          border-color: #C31200 !important; background-color: #fbf4f4 !important;
        `
      : ""}
`;

export const NumStyledInput = styled.input`
  width: 110px;
  height: 28px !important;
  margin-right : 185px;
  border: 1px solid #a9a9a9 !important;
  color: #333;
  padding-left: 5px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  font-size: 1rem !important;
  font-family: Verdana;
  //border-radius: 4px;
  &:disabled {
    border-color: #babfc7 !important;
    color: #898989;
    background-color: #fff;
  }
  &:focus,
  :focus-visible {
    outline: none;
  }
  ${(props) =>
    props.error
      ? css`
          border-color: #C31200 !important; background-color: #fbf4f4 !important;
        `
      : ""}
      ${props => ((props.id === "input_reconnectTime" || props.id === "input_portNumber") && props.className === "red" ? css`border-color:#C31200 !important` : css`border-color:black !important`)};
`;

export const MiniStyledInput = styled.input`
  width: 260px;
  height: 28px !important;
  margin-right : 5px;
  border: 1px solid #a9a9a9 !important;
  color: #333;
  padding-left: 5px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  font-size: 1rem !important;
  font-family: Verdana;
  //border-radius: 4px;
  &:disabled {
    border-color: #babfc7 !important;
    color: #898989;
    background-color: #fff;
  }
  &:focus,
  :focus-visible {
    outline: none;
  }
  ${(props) =>
    props.error
      ? css`
          border-color: #C31200 !important; background-color: #fbf4f4 !important;
        `
      : ""}
      ${props => ((props.id === "input_failoverHubURI" && props.className === "red") || (props.id === "input_primaryHubURI" && props.className === "red") ? css`border-color:#C31200 !important` : css`border-color:black !important`)}
`;

export const MultiTagWrapper = styled.div`
  min-height: 47px;
  #cert-name {
    /* min-width: 100px; */
    padding-top: 5px;
    padding-right: 15px;
  }
  > p {
    color: #C31200;
    font-size: 10px;
    font-style: italic;
    margin-top: 3px;
  }
  // To hide up/down arrow for number fields
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  > label#affixLabel {
    margin-bottom: 20px;
    margin-left: 10px;
    font-family: Verdana;
  }
`;

export const FormErrorSectionDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  svg {
    color: #C31200;
    margin-left: 3px;
    font-size: 11px;
    // margin-right: 5px;
    margin-top: 2px;
  }
  > p {
    color: #C31200;
    font-size: 13px;
    margin: 8px -261px 0 0;
    font-weight: 600;
  }
  ${(props) => props.disabled ? css`display : none` : ""}
`;

export const Button = styled.label`
 background-color: ${props => (props.primary ? "#61ae34" : "#333333")} ;
    border-color: ${props => (props.primary ? "#61ae34" : "#333333")} !important;
    width: ${props => (props.width ? props.width : "90px")};
    height: ${props => (props.height ? props.height : "29px")};
    font-size: 13px !important;
    font-weight: normal !important;
    margin: ${props => (props.ml ? props.ml : "5px 5px 25px 20px")} !important;
    color: #fff !important;
    font-family: Verdana !important;
    text-transform: none !important;
    border-radius: 2px;
    text-align: center;
    padding-top: 7px;
    &:hover {
      cursor: pointer;
      background-color: #000000;
  }
`;

export const UploadButton = styled.label`
  padding: 5px 23px 7px 23px;
  margin : 0 0 25px 302px;
  border-radius : 3px;
  color: #ffffff;
  box-shadow: none;
  background-color: #333333;
  width: auto;
  height: 29px;
  text-transform: capitalize;
  font-weight: 600;
  &:hover {
      background-color: #000000;
      cursor: pointer;
  }
  justify-content: center;
  align-items: center;
  font-size: .9rem;
  font-family: Verdana;
  ${(props) => props.disabled ?
    css`
        &:hover {
          background-color: dimgray;
        }
        color: #ffffff;
        background-color: dimgray; 
        opacity: 0.8;
        cursor:default !important;` : ""}
`;

export const UploadCertiButton = styled.button`
  padding: 5px 23px 7px 23px;
  margin : 0 0 25px 302px;
  border-radius : 3px;
  color: #ffffff;
  box-shadow: none;
  background-color: #333333;
  width: auto;
  height: 29px;
  text-transform: capitalize;
  font-weight: 600;
  &:hover {
      background-color: #000000;
      cursor: pointer;
  }
  justify-content: center;
  align-items: center;
  font-size: .9rem;
  font-family: Verdana;
  ${(props) => props.disabled ?
    css`
        &:hover {
          background-color: dimgray;
        }
        color: #ffffff;
        background-color: dimgray; 
        opacity: 0.8;
        cursor:default !important;` : ""}
`;

export const RadioButton = styled.input`
  width: 16px;
  height: 16px;
  margin: 7px 5px 7px 0px;
  vertical-align: middle;
`